import './App.css';
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes , useLocation } from 'react-router-dom';
import CategoriesAll from './pages/CategoriesAll';
import AllImageCategories from './pages/categoriesall/AIImageCategories';
import DesignGenerators from './pages/categoriesall/imagecategories/DesignGenerators';
import LoginPage from './pages/Login';
import CaptionsSubtitle from './pages/categoriesall/TextWriting/CaptionsSubtitle';
import JustLaunched from './pages/JustLaunched';
import MyProfile from './pages/MyProfile';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import FeedbackForm from './pages/FeedbackForm';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import SignupPage from './pages/SignUp';
import EditProfile from './pages/EditProfile';
import Dashboard from './pages/Dashboard';
import Help from './pages/Help';
import AnimeCartoonGenerator from './pages/AnimeCartoonGenerator';
import ToolListBySubCategory from './pages/categoriesall/TextWriting/ToolListBySubCategory';
import { ToastContainer } from 'react-toastify';
import Alert from './components/Alert';
import { useEffect, useState } from 'react';
import CourseDashboard from './pages/CourseDashboard';
import CourseEnrollment from './pages/CourseEnrollment';
import PaymentPage from './components/PaymentPage';
import PaidCourseEnrollment from './pages/PaidCourseEnrollment';
import UserCourseCertification from './pages/coursedashboard/UserCourseCertification';
import Certificate from './components/profile/Certificate';
import PrivateComponent from './components/PrivateComponent';
import Notifications from './pages/Notifications';
import ReactGA from "react-ga4";
import usePageTracking from './components/usePageTracking';
import ToolDetail from './pages/ToolDetail';
import { Helmet } from 'react-helmet';
import MyPrompt from './pages/MyPrompt';
import AIPrompt from './pages/AIPrompt';
import AIPromptDetailPage from './pages/AIPromptDetailPage';
import AllGuide from './pages/AllGuide';
import ChatgptGuide from './pages/ChatgptGuide';
import ClaudeGuide from './pages/ClaudeGuide';
import GoogleFlowGuide from './pages/GoogleFlowGuide';
import GeminiGuide from './pages/GeminiGuide';

import MyPromptInstagram from './pages/MyPromptInstagram';
import MyPromptBundle from './pages/MyPromptBundle';
import PromptsClone from './pages/PromptsClone';
import PromptDetailPage from './pages/PromptDetailPage';
import Home2 from './pages/Home2';
import CouponPage from './pages/CouponPage';
import MypurchasePrompts from './pages/MypurchasePrompts';
import NetworkStatusNotifier from './components/NetworkStatusNotifier';
import CreatorProfilePage from './pages/CreatorProfilePage';

// ✅ LAZY IMPORTS (Heavy Pages)
import Home3 from './pages/Home3';
const AiTutorials = React.lazy(() => import('./pages/AiTutorials'));
const CourseBundle = React.lazy(() => import('./pages/training/CourseBundle'));
const AiGadgets = React.lazy(() => import('./pages/AiGadgets'));
const AiEvents = React.lazy(() => import('./pages/AiEvents'));
const CourseDetail = React.lazy(() => import('./pages/CourseDetail'));
const CourseDetailById = React.lazy(() => import('./pages/CourseDetailById'));
const News = React.lazy(() => import('./pages/News'));
const NewsDetails = React.lazy(() => import('./pages/NewsDetails'));
const UserCourseDashboard = React.lazy(() => import('./pages/coursedashboard/UserCourseDashboard'));

const CourseLanding = React.lazy(() => import('./pages/CourseLanding'));
const WorkshopLanding = React.lazy(() => import('./pages/WorkshopLanding'));
const TrainingLanding = React.lazy(() => import('./pages/TrainingLanding'));
const StoreLanding = React.lazy(() => import('./pages/StoreLanding'));
const PromptsBundle = React.lazy(() => import('./pages/PromptsBundle'));
const MyPromptBundleDetail = React.lazy(() => import('./pages/MyPromptBundleDetail'));
const CourseLandingNew = React.lazy(() => import('./pages/CourseLanding_hold'));
const CourseLandingDetails = React.lazy(() => import('./pages/CourseLandingDetails'));
const CourseLandingDetailsOld = React.lazy(() => import('./pages/CourseLandingDetailsOld'));
const DiscountPopup = React.lazy(() => import('./pages/DiscountPopup'));

const Membership = React.lazy(() => import('./pages/Membership'));
const Training = React.lazy(() => import('./pages/training/Training'));
const TrainingDetails = React.lazy(() => import('./pages/training/TrainingDetails'));
const WorkshopTrainingDetails = React.lazy(() => import('./pages/training/WorkshopTrainingDetails'));
const AiAdsMastery = React.lazy(() => import("./pages/training/AiAdsMastery"));
const TrainingAiAdsMastery = React.lazy(() => import('./pages/training/TrainingAiAdsMastery'));
const FreeFridayThankyou = React.lazy(() => import('./pages/FreeFridayThankyou'));
const FreeAiWorkshop = React.lazy(() => import('./pages/FreeAiWorkshop'));
const ThankYouForAutomationWorkshop = React.lazy(() => import('./pages/ThankYouForAutomationWorkshop'));
const ThankYouForAdsMastery = React.lazy(() => import('./pages/ThankYouForAdsMastery'));
const FreeAiKidsWorkshop = React.lazy(() => import('./pages/FreeAiKidsWorkshop'));
const FreeAiKids = React.lazy(() => import('./pages/FreeAiKids'));
const AiKidsWorkshops = React.lazy(() => import('./pages/AiKidsWorkshops'));
const FreeFridayLandingPage = React.lazy(() => import('./pages/FreeFridayLandingPage'));
const AiWorkshopLandingPage = React.lazy(() => import('./pages/AiWorkshopLandingPage'));
const AiWorkshopRegisterPage = React.lazy(() => import('./pages/AiWorkshopRegisterPage'));
const AdsmasteryWorkshop = React.lazy(() => import('./pages/training/AdsmasteryWorkshop'));
const MonthlyWorkshopPage = React.lazy(() => import('./pages/MonthlyWorkshopPage'));
const AiCommunityPage = React.lazy(() => import('./pages/AiCommunityPage'));
const AiResourcesPage = React.lazy(() => import('./pages/AiResourcesPage'));
const AiResourcesClaudePage = React.lazy(() => import('./pages/AiResourcesClaudePage'));
const AiResourcesChatgptPage = React.lazy(() => import('./pages/AiResourcesChatgptPage'));
const ClaudeLandingPage = React.lazy(() => import('./pages/ClaudeLandingPage'));
const FilmMakingLandingPage = React.lazy(() => import('./pages/FilmMakingLandingPage'));
const AIAvatarLandingPage = React.lazy(() => import('./pages/AIAvatarLandingPage'));
const AgenticAILandingPage = React.lazy(() => import('./pages/AgenticAILandingPage'));
const MakeMoneyLandingPage = React.lazy(() => import('./pages/MakeMoneyLandingPage.jsx'));


function App() {
  const [showPopup, setShowPopup] = useState(false)
  const [alertBox, setAlertBox] = useState(false)
  const [alert, setAlert] = useState({
    message: "",
    color: ""
  })
  const showAlert = (message, color) => {
    setAlert({ message: message, color: color })
  }

  const location = useLocation();



  
  useEffect(() => {
    ReactGA.initialize("G-ZCWE0G2CCF");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  // Optional: Track initial pageview
  // ReactGA.initialize("G-ZCWE0G2CCF"); // Replace with your Measurement ID
  // ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  usePageTracking();


useEffect(() => {
  const blockedPrefixes = [
    "/prompts",
    "/myprompts",
    "/coupons",
    "/ai-ads-mastery",
    "/trainings/ai-ads-mastery",
  ];

  // ❌ Block popup on prompts & similar pages
  if (blockedPrefixes.some(path => location.pathname.startsWith(path))) {
    setShowPopup(false);
    return;
  }

  const intervals = [1 * 60 * 1000, 10 * 60 * 1000, 20 * 60 * 1000];
  const pauseAfterCycle = 5 * 60 * 1000;

  let intervalIndex = 0;
  let timeoutId;

  const showNextPopup = () => {
    setShowPopup(true);
    localStorage.setItem("popup_last_shown", Date.now().toString());

    intervalIndex++;
    timeoutId = setTimeout(
      showNextPopup,
      intervalIndex >= intervals.length
        ? pauseAfterCycle
        : intervals[intervalIndex]
    );

    if (intervalIndex >= intervals.length) intervalIndex = 0;
  };

  timeoutId = setTimeout(showNextPopup, intervals[intervalIndex]);

  return () => clearTimeout(timeoutId);

}, [location.pathname]); // ✅ CRITICAL





  return (
    <>
    {/* <NetworkStatusNotifier/> */}
      <Helmet>
        <title>{'Next Future AI'}</title>

      </Helmet>
      <ToastContainer />
      {
        // (showPopup) && <DiscountPopup showAlert={showAlert} setAlertBox={setAlertBox} setShowPopup={setShowPopup} />
      }

      


      <Alert alert={alert} alertBox={alertBox} setAlertBox={setAlertBox} />
       <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Home3 />} />
        <Route path="/course-bundle" element={<CourseBundle />} />
        <Route path="/memberships" element={<Membership />} />
        <Route path="/trainings" element={<Training />} />
        <Route path="/trainings/training-details" element={<TrainingDetails />} />
        <Route path="/trainings/ai-automation-bootcamp" element={<TrainingDetails />} />
        <Route path="/trainings/ai-agents-&-automation-mastery" element={<TrainingDetails />} />
        <Route path="/workshop/ai-agents-&-automation-mastery" element={<WorkshopTrainingDetails />} />
        <Route path="/ai-ads-mastery" element={<AiAdsMastery />} />
        <Route path="/trainings/ai-ads-mastery" element={<TrainingAiAdsMastery />} />
        <Route path="/free-friday-thankyou" element={<FreeFridayThankyou />} />
        <Route path="/free-Ai-workshop" element={<FreeAiWorkshop />} />
        <Route path="/thank-you-for-automation-workshop" element={<ThankYouForAutomationWorkshop />} />
         <Route path="/thank-you-for-ads-mastery-workshop" element={<ThankYouForAdsMastery />} />
        <Route path="/free-Ai-kids-workshop" element={<FreeAiKidsWorkshop />} />
        <Route path="/ai-for-kids-workshop" element={<AiKidsWorkshops />} />
        <Route path="/trainings/ai-for-kids" element={<FreeAiKids />} />
        <Route path="/free-friday-session" element={<FreeFridayLandingPage />} />
        <Route path="/ai-workshop" element={<AiWorkshopLandingPage />} />
        <Route path="/ai-workshop-registration" element={<AiWorkshopRegisterPage />} />
        <Route path="/workshop/ai-avatar-creation-mastery" element={<AdsmasteryWorkshop />} />
        <Route path="/workshop/ai-masterclass" element={<MonthlyWorkshopPage />} />
        <Route path="/ai-community" element={<AiCommunityPage />} />
        <Route path="/ai-resources" element={<AiResourcesPage />} />
        <Route path="/ai-resources-claude" element={<AiResourcesClaudePage />} />
        <Route path="/ai-resources-chatgpt" element={<AiResourcesChatgptPage />} />
        <Route path="/claude-course" element={<ClaudeLandingPage />} />
        <Route path="/film-making-course" element={<FilmMakingLandingPage />} />
        <Route path="/ai-avatar-course" element={<AIAvatarLandingPage />} />
        <Route path="/agentic-ai-course" element={<AgenticAILandingPage />} />
        <Route path="/make-money-course" element={<MakeMoneyLandingPage />} />
        
        
        <Route path="/creator-profile" element={<CreatorProfilePage />} />
        <Route path="/home2" element={<Home2 />} />
        <Route path="/ai-tool-categories" element={<CategoriesAll showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/ai-image-categories" element={<AllImageCategories />} />
        <Route path="/ai-tools/design-generators" element={<DesignGenerators />} />
        <Route path="/login" element={<LoginPage showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/text-write/captions-or-subtitle" element={<CaptionsSubtitle />} />
        <Route path="/just-launched" element={<JustLaunched />} />
        <Route path="/prompts" element={<MyPrompt />} />
        <Route path="/ai-prompts" element={<AIPrompt />} />
        <Route path="/ai-prompts-detail/:id" element={<AIPromptDetailPage />} />
        <Route path="/all-guide" element={<AllGuide />} />
        <Route path="/chatgpt-guide" element={<ChatgptGuide />} />
        <Route path="/claude-guide" element={<ClaudeGuide />} />
        <Route path="/googleflow-guide" element={<GoogleFlowGuide />} />
         <Route path="/gemini-guide" element={<GeminiGuide />} />
        <Route path="/instaram-prompts" element={<MyPromptInstagram />} />
        <Route path="/my-prompts-bundle/category/:id" element={<MyPromptBundle />} />
        <Route path="/prompts-detail/:id" element={<PromptDetailPage />} />
        <Route path="/prompts/:name/:id" element={<PromptDetailPage />} />
        <Route path="/ai-tutorials" element={<AiTutorials />} />
        <Route path="/ai-gadgets" element={<AiGadgets />} />
        <Route path="/ai-events" element={<AiEvents />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/feedback-form" element={<FeedbackForm showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/signup" element={<SignupPage showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/course-detail" element={<CourseDetail />} />
        <Route path="/help" element={<Help />} />
        <Route path="/subcategory/:subcategory" element={<ToolListBySubCategory />} />
        <Route path="/category/:category" element={<AnimeCartoonGenerator showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/news" element={<News showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/news-details" element={<NewsDetails showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/course-dashboard" element={<CourseDashboard showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/course-enrollment/:id" element={<CourseEnrollment showAlert={showAlert} setAlertBox={setAlertBox} />} />
        <Route path="/tool-detail/:id" element={<ToolDetail />} />
        <Route path="/tool-detail/:tool/:id" element={<ToolDetail />} />
        <Route path="/courses" element={<CourseLanding />} />
        <Route path="/workshops" element={<WorkshopLanding />} />
        <Route path="/store" element={<StoreLanding />} />
        <Route path="/training" element={<TrainingLanding />} />
        <Route path="/prompts-bundle" element={<PromptsBundle />} />
        <Route path="/prompts-bundle-detail/:id" element={<MyPromptBundleDetail />} />
        <Route path="/courses_new" element={<CourseLandingNew />} />
        <Route path="/course-landing" element={<CourseLanding />} />
        <Route path="/course-details/:id" element={<CourseLandingDetails />} />
        <Route path="/course-details-preview/:id" element={<CourseLandingDetailsOld />} />
        <Route path="/:course_name/course-details/:id" element={<CourseLandingDetails />} />
        <Route path="/courses/:course_name" element={<CourseLandingDetails />} />
        <Route path="/courses/:course_name/:id" element={<CourseLandingDetails />} />
        <Route path="/coupon/:id" element={<CouponPage />} />
        <Route element={<PrivateComponent />}>
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/edit-profile" element={<EditProfile showAlert={showAlert} setAlertBox={setAlertBox} />} />
          <Route path="/user-course-dashboard/:id" element={<UserCourseDashboard showAlert={showAlert} setAlertBox={setAlertBox} />} />
          <Route path="/paid-course-enrollment/:id" element={<PaidCourseEnrollment showAlert={showAlert} setAlertBox={setAlertBox} />} />
          <Route path="/payment" element={<PaymentPage showAlert={showAlert} setAlertBox={setAlertBox} />} />
          <Route path="/user-course-certification/:id" element={<UserCourseCertification showAlert={showAlert} setAlertBox={setAlertBox} />} />
          <Route path="/certificate" element={<Certificate showAlert={showAlert} setAlertBox={setAlertBox} />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/coupons" element={<CouponPage />} />
          <Route path="/my-purchase-prompts" element={<MypurchasePrompts showAlert={showAlert} setAlertBox={setAlertBox} />} />
          
        </Route>
      </Routes>
      </Suspense>
    </>
  );
}

export default App;
